import styled, { css } from 'styled-components';
import { layout, colors, media } from '@prisjakt/ui-base';
import CheckIconBase from 'mdi-react/CheckboxMarkedCircleIcon';

export const UserSentiment = styled.div`
  padding: ${layout.spacing.small};
  width: 100%;

  ${media.mediumDown`
    padding: 0;
  `};
`;

type FormWrapperProps = {
  visible: boolean;
};

export const FormWrapper = styled.div<FormWrapperProps>(
  props => css`
    display: ${props.visible ? 'block' : 'none'};
  `
);

export const Title = styled.div`
  font-size: 12px;
  color: ${p => p.theme.text.quaternary};
  text-align: center;
`;

export const Thanks = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${colors.green2};
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  padding: ${layout.spacing.small};
`;

export const ThanksMessage = styled.div`
  text-align: center;
  margin-top: ${layout.spacing.xSmall};
  padding: ${layout.spacing.xSmall};
`;

export const CheckIcon = styled(CheckIconBase)`
  margin-top: ${layout.spacing.xSmall};
`;

type DividerProps = {
  visible?: boolean;
};

export const Divider = styled.div<DividerProps>(
  props => css`
    width: 100%;
    height: 1px;
    background: ${props.theme.lines.primary};
    margin-top: ${layout.spacing.small};
    margin-bottom: ${layout.spacing.small};
    display: ${props.visible ? 'block' : 'none'};
  `
);
